<template>
  <div>
    <v-select dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
      label="Select Default Account"></v-select>
    <v-card outlined>
      <v-toolbar dense flat color="grey lighten-3">
        <v-toolbar-title>
          Payment Method
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-row justify="end" v-if="customer">
          <v-col cols="auto">
            <CardOnFile :id="customer.id" :type="type" @submit="reload()" :selectedMerchant="selectedMerchant" />
          </v-col>
          <v-col cols="auto">
            <CreditCard v-if="type === 'customer'" :Cards="cards" @getCard="getCard" :customer="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
            <CreditCard v-else :Cards="cards" @getCard="getCard" :donor="customer" @submit="reload"
              :stripeId="customer.stripeId"></CreditCard>
          </v-col>
        </v-row>

      </v-toolbar>
      <div v-if="customer.MerchantCustomers.length">
        <v-progress-linear v-if="isLoading" size="50" width="7" indeterminate="indeterminate"
          color="pink"></v-progress-linear>

        <div v-for="(cardRows, idx) in cards" :key="idx">
          <!-- <div class='ml-2'>{{ cardRows.name }}</div> -->
          <v-list dense v-if="!isLoading">
            <template v-for="(card, index) in cards">
              <v-list-item :key="index">

                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="card.card_type">{{ card.card_type }}</span><span v-if="card.account_type">{{
                      card.account_type }}</span> - {{ card.last4 }} <span class="text-capitalize">- {{
                        card.payment_method_type }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle><span v-if="card.expiry_month">{{ card.expiry_month }}/{{
                    card.expiry_year
                      }}- </span> <span>{{ card.created_at | moment("L")
                      }}</span></v-list-item-subtitle>
                </v-list-item-content>
                <!-- <v-list-item-action-text v-if="stripeCustomer.default_source === card.id">
                          <v-chip color="blue lighten-2" small>Default</v-chip>
                        </v-list-item-action-text> -->
                <!-- <v-list-item-action>
                          <v-btn color="primary" small @click="deleteCard(card)">Remove</v-btn>

                        </v-list-item-action> -->
                <v-list-item-action>
                  <v-menu bottom right offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="menu-button">
                      <v-list-item @click="deleteCard(card)">
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item>
                      <!-- <v-divider></v-divider>
                            <v-list-item @click="markDefaultCard(card)">
                              <v-list-item-title>Copy this card</v-list-item-title>
                            </v-list-item> -->
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </div>
      </div>

    </v-card>
  </div>
</template>

<script>
import donationCategoryService from "@/modules/DonationCategory/service.js";
import payCompassService from "@/modules/PayCompass/service.js";
import { mapGetters } from "vuex";
const CreditCard = () => import("@/modules/Customer/components/CreditCard.vue");
const CardOnFile = () => import("@/modules/SecretManager/components/CardsOnFile.vue");

export default {
  name: "Paymentmethod-list",
  props: ['type', 'customer'],
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      cards: [],
      isLoading: false,
    };
  },
  computed: {
    // ...mapGetters("customer", ["customer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    CreditCard,
    CardOnFile,
  },
  async created() {
    await this.getDonationCategoryList();
  },
  watch: {
    selectedMerchant(val) {
      // console.log('val', val)
      // console.log('customer', customer)
      if (val) {
        // this.cards = []
        this.getCard()
      }

    },
  },
  methods: {
    async reload() {
      this.isLoading = true
      if (this.selectedMerchant) {
        this.getCard()
      }

    },
    deleteCard(card) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {

          payCompassService.deleteCard({ id: card.id, donationCategoryId: this.selectedMerchant.id }).then(result => {
            console.log('result', result)
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Card was remove from the file",
              });
            this.reload()
          })
        }
      });

    },
    getCard() {
      this.cards = null
      //console.log('get card customer', this.customer, this.selectedMerchant)
      let payCompassId = null
      this.customer.MerchantCustomers.map(row => {
        if (row.DonationCategoryId === this.selectedMerchant.id) {
          payCompassId = row.payCompassId
        }
      })
      // console.log('payCompassId', payCompassId)
      if (payCompassId) {
        // console.log('i am getting card')
        payCompassService.getAllCard(payCompassId, { donationCategoryId: this.selectedMerchant.id }).then(response => {
          // console.log('card response', response)
          if (response.data.length) {
            this.cards = response.data
          }

          this.isLoading = false
        }).catch(error => {
          console.log('error', error)
          this.isLoading = false
        })
      }
    },
    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        //console.log('response merchant', response)
        this.MerchantAccount = response.data;
        if (this.type === 'customer') {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
              this.selectedMerchant = row
            }
          })
        } else {
          this.MerchantAccount.map(row => {
            if (row.id === this.currentBusiness.DefaultDonationId) {
              this.selectedMerchant = row
            }
          })
        }
        this.getCard()
      });
    },
  }
}
</script>

<style scoped></style>